import React, { memo } from "react";
import useStyles from "./styles";

import { Grid } from "@material-ui/core";
import { Images } from "config/images";

const InfoLoyalty = props => {
	const classes = useStyles();
	const { loyaltyDetail } = props;

	return (
		<Grid classes={{ root: classes.root }}>
			<Grid classes={{ root: classes.header }}>
				<img src={Images.icTimer} alt="icTimer" /> Thời gian
			</Grid>
			<Grid classes={{ root: classes.textTime }}>
				<Grid>TG tích điểm:</Grid>
				<Grid classes={{ root: classes.valueTime }}>{`${
					loyaltyDetail?.startTimeApply || "-"
				} - ${loyaltyDetail?.endTimeApply || "-"}`}</Grid>
			</Grid>
			<Grid classes={{ root: classes.textTime }}>
				<Grid>TG sử dụng điểm:</Grid>
				<Grid classes={{ root: classes.valueTime }}>
					{loyaltyDetail?.pointExpirationDate || "-"}
				</Grid>
			</Grid>
			<Grid classes={{ root: classes.textTime }}>
				<Grid>TG trả thưởng:</Grid>
				<Grid classes={{ root: classes.valueTime }}>{`${
					loyaltyDetail?.startTimeReward || "-"
				} - ${loyaltyDetail?.endTimeReward || "-"}`}</Grid>
			</Grid>
		</Grid>
	);
};

export default memo(InfoLoyalty);
